import { render, staticRenderFns } from "./addClassDialog.vue?vue&type=template&id=06aea9d3&scoped=true&"
import script from "./addClassDialog.vue?vue&type=script&lang=js&"
export * from "./addClassDialog.vue?vue&type=script&lang=js&"
import style0 from "./addClassDialog.vue?vue&type=style&index=0&id=06aea9d3&lang=less&scoped=true&"
import style1 from "./addClassDialog.vue?vue&type=style&index=1&id=06aea9d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aea9d3",
  null
  
)

export default component.exports